/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Badges from "../components/Badges";
import {
  postPassengersByAdmin,
  updatePassengerDetailsByAdmin,
  updatePassengerStatusByAdmin,
} from "../api/passengerApi";
import { formatDate } from "../utils/helper";
import PassengerProfileModal from "../components/PassengerProfileModal";
import { FiRefreshCw } from "react-icons/fi";
import Skeleton from "react-loading-skeleton";
import AccessControl from "../components/AccessControl";

const statusFilters = ["All", "Active", "Inactive", "Blocked"];

export default function Users() {
  const [statusFilter, setStatusFilter] = useState("All");
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null); // 👈 for modal

  const filtered = users.filter((u) => {
    const matchStatus =
      statusFilter === "All" ||
      u.status.toLowerCase() === statusFilter.toLowerCase();
    const matchSearch =
      search === "" ||
      u.name.toLowerCase().includes(search.toLowerCase()) ||
      u.phone.includes(search);
    return matchStatus && matchSearch;
  });

  const handleStatusChange = async (id, newStatus) => {
    const res = await updatePassengerStatusByAdmin(id, { status: newStatus });
    if (res.success) {
      setUsers((prev) =>
        prev.map((u) => (u._id === id ? { ...u, status: newStatus } : u)),
      );
    }
  };
  const fetchUsers = async () => {
    setLoading(true);
    const payload = {
      n_limit: 10,
      n_page: 1,
      c_search_term: search,
    };
    const res = await postPassengersByAdmin(payload);
    if (res.success) {
      setUsers(res.passengers);
    }
    setLoading(false);
  };

  const handleDetailsChange = async (id, updatedData) => {
    const res = await updatePassengerDetailsByAdmin(id, {
      payload: updatedData,
    });
    if (res.success) {
      setUsers((prev) =>
        prev.map((u) => (u._id === id ? { ...u, ...updatedData } : u)),
      );
    }
    setSelectedUser(null); // Close modal after update
    fetchUsers(); // Refresh list to get latest data after details update
  };

  useEffect(() => {
    fetchUsers();
  }, [search]);

  return (
    <div>
<AccessControl
        allowedRoles={["SUPERADMIN", "ADMIN","HR", "NSM", "RSM", "ASM", "TSO"]}
        redirectTo="/404"
      />
      {/* ✅ Dynamic stats */}
      <div className="stat-grid section">
        <div className="stat-card">
          <div className="stat-label">Total Passengers</div>
          <div className="stat-value">{users.length}</div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Active</div>
          <div className="stat-value" style={{ color: "#0F6E56" }}>
            {users.filter((u) => u.status.toLowerCase() === "active").length}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Inactive</div>
          <div className="stat-value" style={{ color: "#854F0B" }}>
            {users.filter((u) => u.status.toLowerCase() === "inactive").length}
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Blocked</div>
          <div className="stat-value" style={{ color: "#A32D2D" }}>
            {users.filter((u) => u.status.toLowerCase() === "blocked").length}
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card">
        {/* filters + search */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
            flexWrap: "wrap",
            gap: 10,
          }}
        >
          <div className="filter-tabs" style={{ margin: 0 }}>
            {statusFilters.map((s) => (
              <button
                key={s}
                className={`filter-tab ${statusFilter === s ? "active" : ""}`}
                onClick={() => setStatusFilter(s)}
              >
                {s}
              </button>
            ))}
          </div>
          <div className="search-wrap">
            <input
              className="search-input"
              placeholder="Search passengers..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <button onClick={fetchUsers} className="btn-outline-green btn-sm">
            <FiRefreshCw
              style={{
                marginRight: 6,
                animation: loading ? "spin 1s linear infinite" : "none",
              }}
            />
          </button>
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>User</th>
                <th>Phone</th>
                <th>Joined</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

    <tbody>
  {loading ? (
    [...Array(6)].map((_, i) => (
      <tr key={i}>
        <td>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Skeleton circle width={32} height={32} />
            <Skeleton width={100} height={14} />
          </div>
        </td>

        <td>
          <Skeleton width={100} height={14} />
        </td>

        <td>
          <Skeleton width={120} height={14} />
        </td>

        <td>
          <Skeleton width={80} height={20} borderRadius={20} />
        </td>

        <td>
          <div style={{ display: "flex", gap: 6 }}>
            <Skeleton width={60} height={28} />
            <Skeleton width={70} height={28} />
          </div>
        </td>
      </tr>
    ))
  ) : filtered.length === 0 ? (
    <tr>
      <td
        colSpan={5}
        style={{
          textAlign: "center",
          padding: "30px",
          color: "#888",
        }}
      >
        No users found
      </td>
    </tr>
  ) : (
    filtered.map((u) => (
      <tr key={u._id}>
        <td>{u.name}</td>
        <td>{u.phone}</td>
        <td>{formatDate(u.createdAt)}</td>
        <td>
          <Badges status={u.status} />
        </td>
        <td>
          <div style={{ display: "flex", gap: 6 }}>
            <button
              className="btn-outline-green btn-sm"
              onClick={() => setSelectedUser(u)}
            >
              View
            </button>

            {u.status.toLowerCase() === "blocked" ? (
              <button
                className="btn btn-sm"
                style={{ background: "#E1F5EE", color: "#0F6E56" }}
                onClick={() => handleStatusChange(u._id, "active")}
              >
                Unblock
              </button>
            ) : (
              <button
                className="btn btn-sm"
                style={{ background: "#FCEBEB", color: "#A32D2D" }}
                onClick={() => handleStatusChange(u._id, "blocked")}
              >
                Block
              </button>
            )}
          </div>
        </td>
      </tr>
    ))
  )}
</tbody>

          </table>
        </div>
      </div>

      {/* ✅ Modal for user details */}
      {selectedUser && (
        <PassengerProfileModal
          passenger={selectedUser}
          onClose={() => setSelectedUser(null)}
          onUpdateStatus={handleStatusChange}
          onUpdateDetails={handleDetailsChange}
        />
      )}
    </div>
  );
}
